import React from 'react';
import { Box, Card, CardContent, Typography, Container, Grid } from '@mui/material';
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import PageLayout from "examples/LayoutContainers/PageLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";


export default function PrivacyPolicy() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      
        <Container maxWidth="md">
          <Box sx={{ padding: 1 }}>
            <Card sx={{ maxWidth: '100%' }}>
              <CardContent sx={{ padding: 8 }}>
                <Typography variant="h4" gutterBottom>
                  Privacy Policy
                </Typography>
                <Typography variant="body1" paragraph>
                  ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679
                </Typography>
                <Typography variant="body1" paragraph>
                  <b>Titolare del Trattamento dei Dati</b>
                </Typography>
                <Typography variant="body1" paragraph>
                  Titolare del trattamento è Synova s.r.l.
                  Il Titolare del trattamento è reperibile all’indirizzo e-mail privacy@synova.it
                </Typography>
                <Typography variant="body1" paragraph>
                  <b>Finalità del trattamento</b>
                </Typography>
                <Typography variant="body1" paragraph>
                  I suoi dati saranno trattati per le seguenti finalità:
                  <div >
                    <div><b>1.</b> per la gestione delle richieste di informazione da parte degli utenti attraverso il form e/o l’invio di mail e altri contatti;</div>
                    <div><b>2.</b> per l’invio di newsletter e materiale informativo previo consenso espresso dell’interessato;</div>
                    <div><b>3.</b> per finalità connesse all’attuazione di adempimenti relativi a obblighi legislativi, precontrattuali o contrattuali.</div>
                  </div>
                  Le informazioni di cui al punto 1 e 2 potranno essere cancellate o modificate in qualsiasi momento sotto esplicita richiesta da parte dell’interessato.
                </Typography>
                <Typography variant="body1" paragraph>
                  <b>Modalità del trattamento</b>
                </Typography>
                <Typography variant="body1" paragraph>
                  I dati personali degli utenti sono trattati con le opportune misure di sicurezza; tali misure sono utili a impedire la divulgazione, la modifica o altri utilizzi non autorizzati. Oltre al Titolare, altri soggetti autorizzati potrebbero avere accesso ai Dati Personali ed eventuali soggetti terzi debitamente designati dal Titolare.
                </Typography>
                <Typography variant="body1" paragraph>
                  <b>Conseguenze del rifiuto dei dati</b>
                </Typography>
                <Typography variant="body1" paragraph>
                  La natura del conferimento per le finalità è facoltativa, in assenza di esso non sarà possibile soddisfare la sua richiesta, implicherà l’impossibilità di ricevere le informazioni richieste, la mancata iscrizione alla newsletter, la mancata stipula del contratto.
                </Typography>
                <Typography variant="body1" paragraph>
                  <b>Periodo di conservazione</b>
                </Typography>
                <Typography variant="body1" paragraph>
                  I Dati sono trattati e conservati per il tempo richiesto dalle finalità per le quali sono stati raccolti. Pertanto:
                  <div>
                    <li>I Dati Personali raccolti per la gestione delle richieste verranno conservati per un termine di 24 mesi;</li>
                    <li>I Dati Personali raccolti con finalità di marketing e promozionali saranno conservati per un termine di 24 mesi;</li>
                    <li>I Dati Personali raccolti per scopi collegati all’esecuzione di un contratto tra il Titolare e l’Utente saranno trattenuti sino a quando sia completata l’esecuzione di tale contratto.</li>
                    <li>I Dati Personali raccolti per finalità riconducibili all’interesse legittimo del Titolare saranno trattenuti sino al soddisfacimento di tale interesse.</li>
                  </div>
                  Il Titolare potrebbe essere obbligato a conservare i Dati Personali per un periodo più lungo in ottemperanza ad un obbligo di legge o per ordine di un’autorità.
                  Al termine del periodo di conservazione i Dati Personali saranno cancellati o resi anonimi. Pertanto, allo spirare di tale termine il diritto di accesso, cancellazione, rettificazione ed il diritto alla portabilità dei Dati non potranno più essere esercitati.
                </Typography>
                <Typography variant="body1" paragraph>
                  <b>Comunicazione dei dati</b>
                </Typography>
                <Typography variant="body1" paragraph>
                  I dati personali non saranno oggetto di comunicazione a terzi.
                </Typography>
                <Typography variant="body1" paragraph>
                  <b>Diritti dell’interessato</b>
                </Typography>
                <Typography variant="body1" paragraph>
                  Gli Utenti possono esercitare determinati diritti con riferimento ai Dati trattati dal Titolare. In particolare, l’Utente ha il diritto di:
                  <div>
                    <li>revocare il consenso in ogni momento;</li>
                    <li>accedere ai propri Dati;</li>
                    <li>verificare e chiedere la rettifica;</li>
                    <li>ottenere la limitazione del trattamento;</li>
                    <li>ottenere la cancellazione o rimozione dei propri Dati Personali;</li>
                    <li>proporre reclamo.</li>
                  </div>
                  Come esercitare i diritti: Per esercitare i diritti dell’Utente, gli Utenti possono indirizzare una richiesta agli estremi di contatto del Titolare indicati in questo documento. Le richieste sono depositate a titolo gratuito ed evase dal Titolare nel più breve tempo possibile, in ogni caso entro un mese.
                </Typography>
                <Typography variant="body1" paragraph>
                  <b>Le basi giuridiche per il trattamento dei dati personali in questo contesto</b>
                  sono l’art. 6 (1) lett. c del RGPD e dell’art. 6 (1) lett. f GDPR. Nostro legittimo interesse è la gestione dei cookie e delle tecnologie similari utilizzate e dei relativi consensi.
                  Il conferimento dei dati personali non è contrattualmente richiesto né necessario per la conclusione di un contratto. Non sei obbligato a fornire i dati personali. Se non fornisci i dati personali, non saremo in grado di gestire i tuoi consensi.
                </Typography>
                <Typography variant="body1" paragraph>
                  <b>Modifiche a questa privacy policy</b>
                </Typography>
                <Typography variant="body1" paragraph>
                  Il Titolare del Trattamento si riserva il diritto di apportare modifiche alla presente privacy policy in qualunque momento dandone informazione agli Utenti su questa pagina e, se possibile qualora tecnicamente e legalmente fattibile, inviando una notifica agli Utenti attraverso uno degli estremi di contatto di cui è in possesso il Titolare. Si prega dunque di consultare regolarmente questa pagina, facendo riferimento alla data di ultima modifica indicata in fondo.
                </Typography>
                <Typography variant="body1" paragraph>
                  Ultima modifica 14 Gennaio 2025
                </Typography>
              </CardContent>
            </Card>
          </Box>
        </Container>
      
      <Footer />
    </DashboardLayout>
  );
}
